import i18n from "i18next";
import { useId } from "@fluentui/react-hooks";
import React, { useState, useEffect } from "react";
import { fetchWrapper } from "../../../helpers/fetchwrapper";

// Fluent UI Imports
import { useNavigate } from "react-router-dom";

import { baseUrl } from "../../../helpers/constants";
import { IAppUserDto } from "../../../Models/IAppUserDto";
import ChangePassword from "./ChangePassword";
import useWindowSize from "../../../helpers/useWindowSize";
import ChangeMail from "./ChangeMail";
import DataProtection from "./DataProtection";
import {
  Breadcrumb,
  BreadcrumbButton,
  BreadcrumbItem,
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  Tab,
  TabList,
  MessageBar,
  MessageBarBody,
  MessageBarActions,
} from "@fluentui/react-components";
import {
  ArrowCounterclockwiseRegular,
  ArrowUndoFilled,
  CheckmarkRegular,
  DismissRegular,
  PersonDeleteRegular,
  PersonEditRegular,
  SaveRegular,
  ShieldLockRegular,
} from "@fluentui/react-icons";
import EditProfile from "./EditProfile";
import { StackShim } from "@fluentui/react-migration-v8-v9";
import Header from "../../Layout/Header";

/* var emailRegEx = /\S+@\S+\.\S+/;
const CheckValidEMail = (value: string): string => {
  return emailRegEx.test(value) ? "" : i18n.t<string>("enterValidEMail");
}; */

interface IManageProps {
  onDismiss?: any;
}

function Manage(props: IManageProps) {
  const navigate = useNavigate();
  const [selectedTabValue, setSelectedTabValue] = useState<string>("profile");
  const [showDeleteAccountDialog, setShowDeleteAccountDialog] = useState(false);

  const [accountValues, setAccountValues] = useState<IAppUserDto | undefined>(
    undefined,
  );
  const [saveAccountValueSuccess, setSaveAccountValueSuccess] =
    useState<string>("");
  const [saveAccountValuesDisabled, setSaveAccountValuesDisabled] =
    useState<boolean>(false);

  const [newMail, setNewMail] = useState<string>("");
  const [saveMailSuccess, setSaveMailSuccess] = useState<string>("");
  const [saveMailError, setSaveMailError] = useState<string>("");
  const [saveMailDisabled, setSaveMailDisabled] = useState<boolean>();

  const [passwordChanged, setPasswordChanged] = useState<string>("");
  const [currentPassword, setCurrentPassword] = useState<string>("");
  const [newPassword, setNewPassword] = useState<string>("");
  const [savePasswordError, setSavePasswordError] = useState<string>("");
  const [savePasswordSuccess, setSavePasswordSuccess] = useState<string>("");
  const [savePasswordDisabled, setSavePasswordDisabled] = useState<boolean>();

  const [unchangedArbeitsgebieteKeys, setUnchangedArbeitsgebieteKeys] =
    useState<string[]>();
  const [arbeitsgebiete, setArbeitsgebiete] = useState<
    { key: string; text: string }[]
  >([]);
  const [arbeitsgebieteKeys, setArbeitsgebieteKeys] = useState<string[]>([]);

  const [branchen, setBranchen] = useState<{ key: string; text: string }[]>([]);
  const [branchenKeys, setBranchenKeys] = useState<string[]>([]);

  const handleAccountValuesChange = (name: string, val: any) => {
    setAccountValues((prevState) =>
      prevState
        ? {
            ...prevState,
            [name]: val,
          }
        : undefined,
    );
  };

  const getCurrentUser = () => {
    fetchWrapper
      .getWithAuth(`${baseUrl}/api/account/getcurrentuser`)
      .then((result: IAppUserDto) => {
        setAccountValues(result);
      })
      .catch((error) => {});
  };

  //Branchen Funktionen
  const getBranchen = () => {
    fetchWrapper.get(`${baseUrl}/api/account/getbranchen`).then((result) => {
      let options: { key: string; text: string }[] = [];
      result.forEach((element: any) => {
        let option: { key: string; text: string } = {
          key: element.brancheGuid,

          text: i18n.language.includes("de") ? element.nameDE : element.nameEN,
        };
        options.push(option);
      });
      setBranchen(options);
    });
  };
  const getUserBranchen = () => {
    if (accountValues) {
      fetchWrapper
        .post(`${baseUrl}/api/account/GetBranchenForUser`, {
          UserGuid: accountValues.id,
        })
        .then((result) => {
          let keys: string[] = [];
          result.forEach((element: any) => {
            keys.push(element.brancheGuid);
          });
          setBranchenKeys(keys);
        });
    }
  };
  function saveUserBranchen() {
    if (accountValues) {
      branchen.forEach((item) => {
        if (branchenKeys?.includes(item.key)) {
          fetchWrapper
            .postWithAuth(`${baseUrl}/api/account/SetBrancheForUser`, {
              UserGuid: accountValues.id,
              BrancheGuid: item.key,
            })
            .then((result: any) => {
              setSaveAccountValueSuccess(result.message);
            })
            .catch((error: any) => {});
        } else {
          fetchWrapper
            .postWithAuth(`${baseUrl}/api/account/RemoveBrancheForUser`, {
              UserGuid: accountValues.id,
              BrancheGuid: item.key,
            })
            .then((result: any) => {
              setSaveAccountValueSuccess(result.message);
            })
            .catch((error: any) => {});
        }
      });
    }
  }
  function onChangeBrancheForUser(
    option?: { key: string; selected: boolean; text: string } | undefined,
  ) {
    if (option && branchenKeys) {
      setBranchenKeys(
        option.selected
          ? [...branchenKeys, option.key as string]
          : branchenKeys.filter((key) => key !== option.key),
      );
      setSaveAccountValuesDisabled(false);
    }
  }

  // Arbeitsgebiete Funktionen
  const getUserArbeitsgebiete = () => {
    if (accountValues) {
      fetchWrapper
        .post(`${baseUrl}/api/account/GetArbeitsgebieteForUser`, {
          UserGuid: accountValues.id,
        })
        .then((result) => {
          let keys: string[] = [];
          result.forEach((element: any) => {
            keys.push(element.arbeitsgebietGuid);
          });
          setArbeitsgebieteKeys(keys);
          setUnchangedArbeitsgebieteKeys(keys);
        });
    }
  };
  function onChangeArbeitsgebietForUser(
    option?: { key: string; selected: boolean; text: string } | undefined,
  ) {
    if (option && arbeitsgebieteKeys) {
      setArbeitsgebieteKeys(
        option.selected
          ? [...arbeitsgebieteKeys, option.key as string]
          : arbeitsgebieteKeys.filter((key) => key !== option.key),
      );
      setSaveAccountValuesDisabled(false);
    }
  }
  function saveUserArbeitsgebiete() {
    if (accountValues) {
      arbeitsgebiete.forEach((item) => {
        setTimeout(() => {
          if (
            arbeitsgebieteKeys?.includes(item.key) &&
            !unchangedArbeitsgebieteKeys?.includes(item.key)
          ) {
            fetchWrapper
              .postWithAuth(`${baseUrl}/api/account/SetArbeitsgebietForUser`, {
                UserGuid: accountValues.id,
                ArbeitsgebietGuid: item.key,
              })
              .then((result: any) => {
                setSaveAccountValueSuccess(result.message);
              })
              .catch((error: any) => {});
          } else if (
            unchangedArbeitsgebieteKeys?.includes(item.key) &&
            !arbeitsgebieteKeys?.includes(item.key)
          ) {
            fetchWrapper
              .postWithAuth(
                `${baseUrl}/api/account/RemoveArbeitsgebietForUser`,
                {
                  UserGuid: accountValues.id,
                  ArbeitsgebietGuid: item.key,
                },
              )
              .then((result: any) => {
                setSaveAccountValueSuccess(result.message);
              })
              .catch((error: any) => {});
          }
        }, 500);
      });
    }
  }

  const changePassword = () => {
    //ChangePassword
    fetchWrapper
      .postWithAuth(`${baseUrl}/api/account/ChangePassword`, {
        OldPassword: currentPassword,
        NewPassword: newPassword,
      })
      .then((result) => {
        setSavePasswordSuccess(result.message);
        setSavePasswordError("");
        setTimeout(() => {
          setSavePasswordSuccess("");
        }, 15000);
        setPasswordChanged(currentPassword);
      })
      .catch((error) => {
        setSavePasswordError(error);
      });
  };
  const changeMail = () => {
    fetchWrapper
      .getWithAuth(
        `${baseUrl}/api/account/SendChangeMailToken?newEmail=${newMail}`,
      )
      .then((result) => {
        setSaveMailSuccess(result.message);
        setTimeout(() => {
          setSaveMailSuccess("");
        }, 10000);
      })
      .catch((error) => {
        setSaveMailError(error);
      });
  };

  const getArbeitsgebiete = () => {
    fetchWrapper
      .get(`${baseUrl}/api/account/getarbeitsgebiete`)
      .then((result: any[]) => {
        result = result.sort((a, b) =>
          i18n.language.includes("de")
            ? a.nameDE < b.nameDE
              ? -1
              : 1
            : a.nameEN < b.nameEN
            ? -1
            : 1,
        );
        let options: { key: string; text: string }[] = [];
        result.forEach((element: any) => {
          let option: { key: string; text: string } = {
            key: element.arbeitsgebietGuid,
            text: i18n.language.includes("de")
              ? element.nameDE
              : element.nameEN,
          };
          options.push(option);
        });
        setArbeitsgebiete(options);
      });
  };

  const FormValidation = () => {
    if (accountValues) {
      if (!accountValues.anrede) {
        return false;
      } else if (!accountValues.vorname) {
        return false;
      } else if (!accountValues.nachname) {
        return false;
      } else if (!accountValues.firma) {
        return false;
      } else if (!accountValues.strasse) {
        return false;
      } else if (!accountValues.hausnummer) {
        return false;
      } else if (!accountValues.postleitzahl) {
        return false;
      } else if (!accountValues.stadt) {
        return false;
      } else return true;
    }
  };

  const updateAccount = (): void => {
    if (FormValidation() && accountValues) {
      fetchWrapper
        .post(`${baseUrl}/api/account/UpdateMyAccount`, accountValues)
        .then((result) => {
          if (result.message == "OK") {
            setSaveAccountValueSuccess(result.message);
            setTimeout(() => {
              setSaveAccountValueSuccess("");
            }, 10000);
          }
        })
        .catch((error) => {});
    }
  };

  const requestDeleteOfAccount = () => {
    fetchWrapper
      .get(`${baseUrl}/api/account/RequestDeleteAccount`)
      .then((result) => {
        setShowDeleteAccountDialog(false);
        handleAccountValuesChange("deleteRequested", true);
      });
  };

  const declineDeleteOfAccount = () => {
    fetchWrapper
      .get(`${baseUrl}/api/account/DeclineRequestDeleteAccount`)
      .then((result) => {
        handleAccountValuesChange("deleteRequested", false);
      });
  };

  useEffect(() => {
    // Aktuellen Benutzer laden
    getCurrentUser();

    // Laender, Branchen, Arbeitsgebiete laden
    getBranchen();
    getArbeitsgebiete();
  }, []);

  useEffect(() => {
    if (accountValues && accountValues.id) {
      getUserArbeitsgebiete();
      getUserBranchen();
    }
  }, [accountValues]);

  const titleId = useId("title");

  const windowSize = useWindowSize();

  return (
    <>
      <Dialog open={showDeleteAccountDialog}>
        <DialogSurface>
          <DialogBody>
            <DialogTitle>
              {i18n.t<string>("requestDeleteOfAccount")}
            </DialogTitle>
            <DialogContent>
              {i18n.t<string>("requestDeleteOfAccountText")}
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => {
                  requestDeleteOfAccount();
                }}
                icon={<CheckmarkRegular />}
                appearance="primary"
              >
                {i18n.t<string>("confirm")}
              </Button>
              <Button onClick={() => setShowDeleteAccountDialog(false)}>
                {i18n.t<string>("cancel")}
              </Button>
            </DialogActions>
          </DialogBody>
        </DialogSurface>
      </Dialog>
      <Header
        HTMLElement={
          <StackShim horizontal verticalAlign="center">
            <Button
              icon={<PersonEditRegular fontSize={24} color="#ff6600" />}
              size="large"
              appearance="subtle"
            >
              {i18n.t<string>("manageAccount").toLocaleUpperCase()}
            </Button>
          </StackShim>
        }
      ></Header>

      {accountValues && accountValues.deleteRequested && (
        <MessageBar intent="warning">
          <MessageBarBody>
            {i18n.t<string>("deleteRequestedWarning")}
          </MessageBarBody>
          <MessageBarActions>
            <Button
              icon={<ArrowUndoFilled />}
              size="large"
              appearance="transparent"
              onClick={() => declineDeleteOfAccount()}
            >
              {i18n.t<string>("undo")}
            </Button>
          </MessageBarActions>
        </MessageBar>
      )}
      {savePasswordError != "" && (
        <MessageBar intent="error">
          {i18n.t<string>(savePasswordError)}
        </MessageBar>
      )}
      {savePasswordSuccess != "" && (
        <MessageBar intent="success">
          {i18n.t<string>(savePasswordSuccess)}
        </MessageBar>
      )}
      {saveMailError != "" && (
        <MessageBar intent="error">{i18n.t<string>(saveMailError)}</MessageBar>
      )}
      {saveMailSuccess != "" && (
        <MessageBar intent="success">
          {i18n.t<string>(saveMailSuccess)}
        </MessageBar>
      )}
      {saveAccountValueSuccess != "" && (
        <MessageBar intent="success">
          {i18n.t<string>("accountSaved")}
        </MessageBar>
      )}
      <div className="lueb-InnerContentBlockPadding2px ">
        {selectedTabValue == "profile" && (
          <>
            <Button
              appearance="transparent"
              disabled={saveAccountValuesDisabled}
              icon={<SaveRegular />}
              onClick={() => {
                updateAccount();
                saveUserBranchen();
                saveUserArbeitsgebiete();
                setSaveAccountValuesDisabled(true);
              }}
            >
              {i18n.t<string>("save")}
            </Button>
            {accountValues && !accountValues.deleteRequested && (
              <Button
                icon={<PersonDeleteRegular />}
                appearance="transparent"
                onClick={() => {
                  setShowDeleteAccountDialog(true);
                }}
              >
                {i18n.t<string>("requestDeleteOfAccount")}
              </Button>
            )}
          </>
        )}
        {selectedTabValue == "email" && (
          <Button
            disabled={saveMailDisabled}
            onClick={() => {
              changeMail();
            }}
            appearance="transparent"
            icon={<SaveRegular />}
          >
            {i18n.t<string>("changeMail")}
          </Button>
        )}
        {selectedTabValue == "password" && (
          <Button
            disabled={savePasswordDisabled}
            onClick={() => {
              changePassword();
            }}
            appearance="transparent"
            icon={<SaveRegular />}
          >
            {i18n.t<string>("changePassword")}
          </Button>
        )}
        {selectedTabValue == "dataProtection" && (
          <Button
            onClick={() => {
              navigate("/privacypolicy");
            }}
            appearance="transparent"
            icon={<ShieldLockRegular />}
          >
            {i18n.t<string>("privacy-policy")}
          </Button>
        )}
      </div>
      <TabList
        onTabSelect={(ev, data) => {
          if (typeof data.value == "string") {
            setSelectedTabValue(data.value);
          }
        }}
        selectedValue={selectedTabValue}
      >
        <Tab value="profile">{i18n.t<string>("profile")}</Tab>
        <Tab value="password">{i18n.t<string>("password")}</Tab>
        <Tab value="email">{i18n.t<string>("email")}</Tab>
        <Tab value="dataProtection">{i18n.t<string>("dataProtection")}</Tab>
      </TabList>
      <div
        className="lueb-ContentBlock"
        style={{
          overflow: "auto",
        }}
      >
        {accountValues && selectedTabValue == "profile" && (
          <EditProfile
            accountValuesChanged={(item: boolean) => {
              setSaveAccountValuesDisabled(item);
            }}
            accountValues={accountValues}
            onAccountValuesChange={(item) => {
              setAccountValues(item);
            }}
            saveDisabled={(item: boolean) => {
              setSaveAccountValuesDisabled(item);
            }}
            branchen={branchen}
            onBranchenChange={(item) => {
              onChangeBrancheForUser(item);
            }}
            selectedBranchenKeys={branchenKeys}
            arbeitsgebiete={arbeitsgebiete}
            onArbeitsgebieteChange={(item) => {
              onChangeArbeitsgebietForUser(item);
            }}
            selectedArbeitsgebieteKeys={arbeitsgebieteKeys}
          />
        )}
        {accountValues && selectedTabValue == "password" && (
          <>
            <ChangePassword
              saveDisabled={(item) => {
                setSavePasswordDisabled(item);
              }}
              userName={accountValues.email}
              onDismiss={() => {}}
              newPassword={(item: string) => {
                setNewPassword(item);
              }}
              currentPassword={(item: string) => {
                setCurrentPassword(item);
              }}
              passwordChanged={passwordChanged}
            />
          </>
        )}
        {accountValues && selectedTabValue == "email" && (
          <ChangeMail
            newMail={(item: string) => {
              setNewMail(item);
            }}
            saveDisabled={(item) => {
              setSaveMailDisabled(item);
            }}
            userName={accountValues.email}
            onDismiss={() => {}}
          />
        )}
        {selectedTabValue == "dataProtection" && <DataProtection />}
      </div>
    </>
  );
}

export default Manage;
